// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

// https://stackoverflow.com/a/54485712
const Nbsp: React.FC = () => '\u00A0' as unknown as React.ReactElement;
export default Nbsp;
